<template>
  <div class="public-content order">
    <div class="breadcrumb">推送平台</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="searchStoreVO" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-input clearable v-model="searchStoreVO.storeCode" placeholder="请输入平台号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input clearable v-model="searchStoreVO.storeName" placeholder="请输入平台名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"></el-col>
          <el-col :span="6"></el-col>
          <el-col :span="6"></el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button @click="searchStoreVO.pageNum = 1, getStoreSpuList()" round>查询</el-button>
            <el-button type="primary" class="search-ok" @click="addStoreDialog = true" round v-permission="'pms:admin:store:add'">添加平台 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table border="" :data="tableData" style="width: 100%">
          <el-table-column prop="storeCode" label="平台号"></el-table-column>
          <el-table-column prop="storeName" label="平台名称"></el-table-column>
          <el-table-column prop="storeTypeName" label="平台类型"></el-table-column>
          <el-table-column label="操作" v-permission="'pms:admin:store:delete'">
            <template slot-scope="scope">
              <span class="color-blue" @click="deleteItem = scope.row, deleteDialog = true">移除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="storeSpuQueryInfo" @changePage="storeSpuchangePage"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" title="删除确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该平台推送？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false" round>取 消</el-button>
        <el-button type="primary" @click="deleteStore(deleteItem)" round>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加平台 -->
    <el-dialog :close-on-click-modal="false" title="添加平台" :visible.sync="addStoreDialog" @closed="closed" width="1100px">
      <el-form :inline="true" :model="storeFormInline" class="demo-form-inline" ref="addForm">
        <el-form-item label="平台号：">
          <el-input style="width:150px" v-model="storeFormInline.code" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input style="width:140px" v-model="storeFormInline.phone" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台类型:">
          <el-select v-model="storeFormInline.storeTypeid" placeholder="请选择">
            <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button @click="getStoreMsg" round>查询</el-button>
      </el-form>
      <el-table ref="multipleTable" :data="storeTableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="平台号" prop="code"></el-table-column>
        <el-table-column label="平台名称" prop="name"></el-table-column>
        <el-table-column label="平台类型" prop="storeType"></el-table-column>
        <el-table-column label="手机号" prop="phone">
          <template slot-scope="scope"> {{ $msg.filterBridal(scope.row.phone) }} </template>
        </el-table-column>
      </el-table>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addStoreDialog = false" round>取 消</el-button>
        <el-button type="primary" @click="addStore()" round>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { storeSpuList, storeSpuAdd, storeSpuRemove } from '@/api/pms'
import { storeGetStoreList, storeTypeGetStoreTypeList } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination,
    CombinedDialog
  },
  inject: ['reload'],
  data () {
    return {
      deleteDialog: false,
      deleteItem: {},
      storeSpuQueryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchStoreVO: {
        saleMan: '',
        storeCode: '',
        storeName: '',
        storePhone: '',
        storeType: ''
      },
      form: {},
      storeTableData: [],
      value1: [],
      formInline: [],
      storeFormInline: {
        page: 1,
        code: '',
        id: '',
        phone: '',
        salename: '',
        salesmanId: '',
        storeTypeid: '',
        auditStatus: 'HANDLE'
      },
      code: '',
      categoryList: [],
      addStoreDialog: false,
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [],
      value: true,
      storeTypeList: [],
      multipleSelection: []
    }
  },
  created () {
    this.getStoreMsg()
    this.getStoreType()
    this.getStoreSpuList()
  },
  methods: {
    closed () {
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection()
      this.storeFormInline.code = ''
      this.storeFormInline.phone = ''
      this.storeFormInline.storeTypeid = ''
      // this.$forceUpdate()
    },
    // 移除平台
    deleteStore (row) {
      storeSpuRemove(row.id).then(res => {
        if (res.data.success) {
          this.$message.success('已移除')
          this.getStoreSpuList()
          this.deleteDialog = false
        }
      })
    },
    // 添加平台
    addStore () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('未勾选平台')
        return
      }
      // let list = new FormData()
      let list = []
      this.multipleSelection.forEach(item => {
        // list.append('storeIdSet', item.id)
        list.push(item.id)
      })
      list = list.join(',')

      storeSpuAdd({ spuId: this.$route.query.id, storeIdSet: list }).then(res => {
        if (res.data.success) {
          this.$message.success('添加成功')
          this.getStoreSpuList()
          this.addStoreDialog = false
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 获取产品推送平台列表
    getStoreSpuList () {
      storeSpuList({
        spuId: this.$route.query.id,
        pageNum: this.storeSpuQueryInfo.pageNum,
        pageSize: this.storeSpuQueryInfo.pageSize,
        searchStoreVO: this.searchStoreVO
      }).then(res => {
        if (res.data.success) {
          this.storeSpuQueryInfo.total = res.data.data.total
          let list = res.data.data.records
          list.forEach(store => {
            this.storeTypeList.forEach(type => {
              if (store.storeType === type.code) {
                store.storeTypeName = type.name
              }
            })
          })
          this.tableData = list
        }
      })
    },
    // 获取平台类型
    getStoreType () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
        }
      })
    },
    // 获取平台列表
    getStoreMsg () {
      storeGetStoreList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, storeVo: this.storeFormInline }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.storeTableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getStoreMsg()
    },
    storeSpuchangePage (val) {
      this.storeSpuQueryInfo = val
      this.getStoreSpuList()
    }
  }
}
</script>
<style scoped lang="less">
@import "index";

@deep: ~">>>";
</style>
